var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIgbg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 295,
    viewBox: "0 0 287 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M287 0H277.164V10.0149H287V0Z",
    fill: "url(#paint0_linear_1728_14881)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M274.085 17.3691H253.372V38.4586H274.085V17.3691Z",
    fill: "url(#paint1_linear_1728_14881)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170.345 30.583H145.679V55.6972H170.345V30.583Z",
    fill: "url(#paint2_linear_1728_14881)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M233.775 38.1855H202.152V70.3837H233.775V38.1855Z",
    fill: "url(#paint3_linear_1728_14881)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M183.333 65.332H167.219V81.7644H183.333V65.332Z",
    fill: "url(#paint4_linear_1728_14881)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M251.812 75.5811H235.69V91.9963H251.812V75.5811Z",
    fill: "url(#paint5_linear_1728_14881)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M198.259 34.6357H185.208V47.9235H198.259V34.6357Z",
    fill: "url(#paint6_linear_1728_14881)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M214.06 88.0874H193.339V109.185H214.06V88.0874Z",
    fill: "url(#paint7_linear_1728_14881)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M228.699 109.181H220.239V117.794H228.699V109.181Z",
    fill: "url(#paint8_linear_1728_14881)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M247.742 140.626H247.582H144.932C129.255 140.626 118.991 149.753 118.991 168.125C118.985 171.852 119.612 175.553 120.845 179.062C123.934 187.667 131.202 195.136 144.932 195.136C150.706 195.136 156.136 194.187 162.498 189.257V175.824H142.817V160.22H178.419V196.845C171.352 207.168 160.039 212.448 144.848 212.448C120.51 212.448 107.736 199.332 103.078 183.395C101.649 178.442 100.936 173.304 100.963 168.142C100.963 144.48 114.652 123.485 144.957 123.485H247.582V106.856H231.217V119.306H216.874V113.641H188.205V104.583H171V86.2962H162.339V62.5065H135.482V41.0068H101.072L39.8062 41.511C29.2514 41.5336 19.1356 45.8145 11.6746 53.4159C4.21356 61.0173 0.0155213 71.3197 0 82.0663L0 253.568C-2.10829e-06 264.326 4.1957 274.644 11.6648 282.254C19.1339 289.863 29.2651 294.142 39.8314 294.149H65.6471V140.703H85.1684V294.149H208.28C217.695 294.156 226.809 290.768 234.004 284.584C241.198 278.4 246.009 269.821 247.582 260.37C247.971 258.113 248.161 255.825 248.153 253.534L247.784 154.324L247.742 140.626ZM85.1684 123.348H65.6471V103.455H85.1684V123.348Z",
    fill: "url(#paint9_linear_1728_14881)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1728_14881",
    x1: 288.586,
    y1: -1.49541,
    x2: 4.17176,
    y2: 272.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4EBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#48B497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#399A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#2374A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1728_14881",
    x1: 290.828,
    y1: 0.825709,
    x2: 6.41368,
    y2: 275.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4EBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#48B497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#399A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#2374A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1728_14881",
    x1: 246.407,
    y1: -45.2297,
    x2: -38.0077,
    y2: 229.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4EBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#48B497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#399A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#2374A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1728_14881",
    x1: 281.303,
    y1: -9.04357,
    x2: -3.11199,
    y2: 265.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4EBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#48B497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#399A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#2374A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1728_14881",
    x1: 269.81,
    y1: -20.9656,
    x2: -14.6045,
    y2: 253.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4EBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#48B497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#399A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#2374A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1728_14881",
    x1: 308.446,
    y1: 19.0975,
    x2: 24.0309,
    y2: 293.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4EBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#48B497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#399A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#2374A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1728_14881",
    x1: 262.035,
    y1: -29.0172,
    x2: -22.3801,
    y2: 245.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4EBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#48B497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#399A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#2374A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1728_14881",
    x1: 296.081,
    y1: 6.27601,
    x2: 11.6667,
    y2: 280.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4EBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#48B497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#399A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#2374A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1728_14881",
    x1: 313.565,
    y1: 24.404,
    x2: 29.1502,
    y2: 298.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4EBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#48B497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#399A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#2374A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1728_14881",
    x1: 290.947,
    y1: 0.947117,
    x2: 6.53249,
    y2: 275.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4EBD96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#48B497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#399A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#2374A1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgbg);
export default __webpack_public_path__ + "static/media/IGBG.ae72dde3904d2d7788ddd071f0c8f079.svg";
export { ForwardRef as ReactComponent };